'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUiTermsCatalogId = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _modal = require('./modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer
var DEFAULT_STATE = {
    catalogId: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_TERMS_MODAL:
            return (0, _extends3.default)({}, state, {
                catalogId: action.payload.catalogId
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.terms;
};

var getUiTermsCatalogId = exports.getUiTermsCatalogId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogId;
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/terms.js
// module id = LHJ5
// module chunks = 57